export function isCachedBiteChoiceActive(cachedBitePromptState) {
  return (
    cachedBitePromptState?.status === "prompting" ||
    cachedBitePromptState?.status === "applying"
  );
}
